import React from 'react';
import cx from 'classnames';
import DragAndDropFileSelector from '~/App/Modules/MyLibrary/Components/DragAndDropUpload/DragAndDropFileSelector';
import { CloseButton } from '../CloseButton';
import Config from '~/Config';

export enum UploadErrorType {
  FileTooLarge = 'file_too_large',
  UnsupportedFile = 'unsupported_file',
}

export const errors: Record<UploadErrorType, React.ReactNode> = {
  [UploadErrorType.FileTooLarge]: (
    <>
      <span>File too large.</span>
      <span>
        Please only upload MP4 & WebM files under{' '}
        {Config.FILE_UPLOAD_MAX_SIZE_MB}MB.
      </span>
    </>
  ),
  [UploadErrorType.UnsupportedFile]: (
    <>
      <span>Error - Unsupported file type</span>
      <span>
        MP4 & WebM files only, max upload file size is{' '}
        {Config.FILE_UPLOAD_MAX_SIZE_MB}MB.
      </span>
    </>
  ),
};

export interface UploaderProps {
  className?: string;
  onFileUpload: (files: File[]) => void;
  onCloseClick?: () => void;
}

export function Uploader({
  className,
  onFileUpload,
  onCloseClick,
}: UploaderProps) {
  return (
    <div
      className={cx(
        className,
        'flex flex-col w-full h-full justify-center p-4 v2-animate-fade-in relative'
      )}
    >
      <DragAndDropFileSelector
        onFileUpload={onFileUpload}
        title='Drop video file here to upload'
        className={cx([
          'w-full h-full v2-border-neutral-300 v2-border-solid v2-border-[1px]',
          'justify-center rounded-2xl v2-bg-neutral-100 !v2-text-neutral-900',
        ])}
        titleClassName='text-[21px] font-bold'
        descriptionClassName='v2-text-neutral-500 !text-xs'
      />
      <CloseButton
        className='uploader-close-btn top-9 right-10'
        onClick={onCloseClick}
      />
    </div>
  );
}
